import '../assets/styles/index.scss';
import '../assets/styles/project.scss';
import { useEffect, useState } from 'react';
import Project from '../data/projects.json';

function ExternalIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
}

function ProjectCard({ project, index }) {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className={`project-card animate-on-load`} style={{ '--card-index': index }}>
      {/* Thumbnail */}
      <div className="project-card__image-wrap">
        {!imageLoaded && (
          <div className="project-card__image-skeleton" aria-hidden="true" />
        )}
        <img
          src={project.thumbnail_img}
          alt={project.title}
          className={`project-card__image ${imageLoaded ? 'loaded' : 'loading'}`}
          loading="lazy"
          decoding="async"
          onLoad={() => setImageLoaded(true)}
        />
        <div className="project-card__overlay">
          <a
            href={project.url}
            target="_blank"
            rel="noreferrer"
            className="project-card__overlay-btn"
            aria-label={`Visit ${project.title}`}
          >
            <ExternalIcon />
            View Live
          </a>
        </div>
      </div>

      {/* Info */}
      <div className="project-card__body">
        <h3 className="project-card__title">{project.title}</h3>
        <p className="project-card__desc">{project.description}</p>

        {/* Tech stack pills */}
        {project.tools && project.tools.length > 0 && (
          <div className="project-card__tools">
            {project.tools.map((tool, i) => (
              <span key={i} className="tool-pill">{tool}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function Projects() {
  useEffect(() => {
    const elements = document.querySelectorAll('.animate-on-load');
    elements.forEach((el, index) => {
      setTimeout(() => el.classList.add('animate-in'), index * 120);
    });
  }, []);

  return (
    <div className="projects-page">
      {/* ─── Page Header ─────────────────────────────────── */}
      <section className="projects-hero">
        <div className="wd-8 w-100">
          <p className="section-label animate-on-load">Portfolio</p>
          <h1 className="projects-hero__title animate-on-load">
            Completed<br />
            <span className="projects-hero__title--accent">Projects</span>
          </h1>
          <p className="projects-hero__sub animate-on-load">
            A curated selection of interfaces and products I've built — focused on clarity,
            performance, and purposeful design.
          </p>
        </div>
      </section>

      {/* ─── Grid ─────────────────────────────────────────── */}
      <section className="projects-grid-section">
        <div className="wd-8 w-100">
          <div className="row gx-5 gy-6">
            {Project.map((project, index) => (
              <div key={index} className="col-12 col-md-6">
                <ProjectCard project={project} index={index} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Projects;
